"use client"

import { useState, useEffect } from "react"
import UsuarioForm from "../components/Usuarios/UsuarioForm"
import UsuarioList from "../components/Usuarios/UsuarioList"
import { supabase } from "../supabaseClient"
import { useAuth } from "../context/AuthContext"

export default function UsuariosPage() {
  const [updateList, setUpdateList] = useState(false)
  const [usuarioParaEditar, setUsuarioParaEditar] = useState(null)
  const { isAdmin } = useAuth()
  const [instituicoes, setInstituicoes] = useState([])

  const handleAdded = () => {
    setUpdateList((prev) => !prev)
    setUsuarioParaEditar(null)
  }

  const handleEdit = (usuario) => {
    setUsuarioParaEditar(usuario)
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  const handleCancelEdit = () => {
    setUsuarioParaEditar(null)
  }

  useEffect(() => {
    const carregarInstituicoes = async () => {
      const { data, error } = await supabase
        .from("instituicoes")
        .select("id, nome, sigla")
        .order("nome")

      if (!error) setInstituicoes(data || [])
      else console.error("Erro ao carregar instituicoes:", error)
    }

    carregarInstituicoes()
  }, [])

  return (
    <div className="usuarios-page" style={{ maxWidth: "1400px", margin: "0 auto", padding: "2rem" }}>
      <h1
        className="page-title"
        style={{
          fontSize: "2rem",
          fontWeight: 700,
          color: "var(--text-primary)",
          marginBottom: "2rem",
          display: "flex",
          alignItems: "center",
          gap: "14px",
          paddingBottom: "16px",
          borderBottom: "3px solid var(--secondary-color)",
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          style={{ color: "var(--secondary-color)" }}
        >
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg>
        Gestão de Usuários
      </h1>

      <UsuarioForm
        onAdded={handleAdded}
        usuarioParaEditar={usuarioParaEditar}
        onCancelEdit={handleCancelEdit}
        instituicoes={instituicoes}
        isAdmin={isAdmin}
      />

      <UsuarioList keyProp={updateList} onEdit={handleEdit} />
    </div>
  )
}
